import { type Theme, css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = css``

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  max-width: ${width.modal.compact};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const tableWrapper = (theme: Theme) => css`
  table,
  figure {
    margin: 0;
  }

  table {
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0px;
    background-color: ${theme.palette.background.main};
    border-spacing: 0px;
    box-sizing: border-box;
    color: ${theme.palette.text.title};
    font-family: Param, Arial, sans-serif;
    font-size: ${fontSize.xs};
    font-style: normal;
    font-weight: 400;
    letter-spacing: normal;
    table-layout: fixed;
    white-space: normal;
    widows: 2;
    word-spacing: 0;
    width: 100%;
  }

  table {
    border: 1px solid ${theme.palette.tertiary.mediumContrast};
    border-radius: ${theme.borderRadius.md};
  }

  th {
    padding: ${size[16]} ${size[12]};
    background-color: ${theme.palette.background.accent};
    border-bottom: 1px solid ${theme.palette.tertiary.mediumContrast};
    font-weight: 500;
    text-align: left;

    &:first-child {
      border-top-left-radius: ${theme.borderRadius.md};
    }

    &:last-child {
      border-top-right-radius: ${theme.borderRadius.md};
    }
  }

  td {
    padding: ${size[8]} ${size[12]};
  }

  tr {
    td {
      border-bottom: 1px solid ${theme.palette.tertiary.mediumContrast};
    }

    &:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`
